<template>
    <div :class="['xx-affix', { empty: !$slots.default }]" ref="refAffix">
        <div class="wrap" ref="refAffixWrap">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { resizeListen } from 'dom-resize';
import { plus } from '@lsfe/tools';

function isValidElement(element) {
    return element instanceof Element;
}

export default {
    name: 'XxAffix',
    props: {
        position: {
            type: String,
            default: 'right', // left/center/right
        },
    },
    data() {
        return {};
    },
    methods: {
        setPosition() {
            const { position } = this;
            const refAffixWrap = this.$refs.refAffixWrap;
            const positionMap = {
                left: 'flex-start',
                center: 'center',
                right: 'flex-end',
            };
            refAffixWrap.style['justify-content'] = positionMap[position];
        },
        setWidth() {
            const refAffix = this.$refs.refAffix;
            const refAffixWrap = this.$refs.refAffixWrap;
            if (isValidElement(refAffix) && isValidElement(refAffixWrap)) {
                const width = +window.getComputedStyle(refAffix).width.slice(0, -2);
                refAffixWrap.style.width = `${plus(width, 20)}px`;
            } else {
                console.error('refAffix or refAffixWrap is not a valid DOM element.');
            }
        },
        forceRun() {
            let nums = 0;

            let timer = setInterval(() => {
                this.setWidth();

                if (nums >= 100) {
                    clearInterval(timer);
                }
                nums++;
            }, 100);
        },
    },
    mounted() {
        this.$nextTick(() => {
            const refAffix = this.$refs.refAffix;
            resizeListen(refAffix, this.setWidth);
            this.setPosition();
            this.forceRun();
        });
    },
};
</script>

<style lang="scss" scoped>
.xx-affix {
    height: 60px;
    &.empty {
        display: none;
    }
    .wrap {
        display: flex;
        position: fixed;
        z-index: 3;
        bottom: 0;
        right: 0;
        background-color: #fff;
        box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.04);
        padding: 10px;
    }
}
</style>
